import moment from "moment";
import { useEffect, useState } from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";

interface AudienciaData {
    linea: number;
    noExpediente: string;
    noUnico: string;
    idTribunal: string;
    descTribunal: string;
    idMateria: string;
    descMateria: string;
    fechaAudiencia: string;
    horaAudiencia: string;
    tipoAudiencia: string;
    estadoAudiencia: string;
    involucrados: string;
    sala: string;
    juez: string;
    totalFilas: number;
    origen: number;
    activo: boolean;
}

interface AudienciasResponse {
    draw: string;
    recordsFiltered: number;
    recordsTotal: number;
    data: AudienciaData[];
}

const RecordAudiencias = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<AudienciaData[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            setIsLoading(true);
            const response = await API.getActionExternal(
                `https://background-check-background-check.up.railway.app/functionaries/audiences?identifier=${id}&start=0&length=10`
            );

            if (response.status) {
                console.log("Fetched audiencias records successfully.", response);
                const data: any = response.data;
                setRecords(data.datos || []);
            } else {
                console.error("Error fetching audiencias records:", response.statusText);
                setRecords([]);
            }
        } catch (error) {
            console.error("Error fetching audiencias records:", error);
            setRecords([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }, [id]);

    if (isLoading) {
        return (
            <Card className="my-4">
                <Card.Body className="text-center py-4">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    if (records.length === 0) {
        return null;
    }

    return (
        <Card className="my-4">
            <Card.Header className="display-4">
                {t("Casos Abiertos")}
                <Badge bg="warning" className="ms-3">
                    {records.length}
                </Badge>
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{t("Expediente")}</th>
                                <th>{t("Tribunal")}</th>
                                <th>{t("Materia")}</th>
                                <th>{t("Fecha y Hora")}</th>
                                {/* <th>{t("Tipo")}</th>
                                <th>{t("Estado")}</th> */}
                                <th>{t("Partes")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((item: any, index) => {
                                console.log("Rendering audiencia item:", item);
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {item.nuc}
                                        </td>
                                        <td className="text-wrap">
                                            {item.tribunal}
                                            {item.sala && item.sala !== "N/D" && (
                                                <>
                                                    <br />
                                                    <small className="text-muted">
                                                        {item.categoriaTribunal}
                                                    </small>
                                                </>
                                            )}
                                        </td>
                                        <td>
                                            {item.materia && item.materia !== "N/D"
                                                ? item.materia
                                                : "-"}
                                        </td>
                                        <td>
                                            {item.fechaDate ? (
                                                <>
                                                    <strong>
                                                        {moment(item.fechaDate).format("DD/MM/YYYY")}
                                                    </strong>
                                                    <br />
                                                    <small>{moment(item.fechaDate).format("HH:mm")}</small>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        {/* <td>
                                            {item.estadoRolAudiencia && item.estadoRolAudiencia !== "N/D"
                                                ? item.estadoRolAudiencia
                                                : "-"}
                                        </td>
                                        <td>
                                            {item.tipoResultado}
                                        </td> */}
                                        <td className="text-wrap">
                                            {item.partes}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
            <Card.Footer className="text-muted">
                <small>
                    <i className="fa fa-info-circle me-2"></i>
                    {t("Total de audiencias encontradas")}: {records.length}
                </small>
            </Card.Footer>
        </Card>
    );
};

export default RecordAudiencias;
